// 文件下载
export function downLoadFunc(src, filename, type) {
  const blobType = type === 'zip' ? 'application/zip' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8';
  const blob = new Blob([src], { type: blobType });
  // console.log(blob)
  const href = window.URL.createObjectURL(blob); // 创建下载的链接
  const a = document.createElement('a');
  a.download = filename;
  a.href = href;
  document.body.appendChild(a);
  a.click(); // 下载
  URL.revokeObjectURL(a.href); // 释放URL 对象
  document.body.removeChild(a); // 删除 a 标签
}
